function ShareLinks() {
    let self = this;
  
    this.init = function()
    {
      if(!self.check())
        return;
  
      self.eventListeners();
    };
  
    this.check = function()
    {
      let items = document.querySelectorAll('.copy-url-link');
      return (items.length > 0);
    };
  
    this.eventListeners = function()
    {
      jQuery('.copy-url-link').on('click', function () {
  
        let dummy = document.createElement('input'),
          text = window.location.href;
  
        document.body.appendChild(dummy);
        dummy.value = text;
        dummy.select();
        document.execCommand('copy');
        document.body.removeChild(dummy);
  
        jQuery(this).addClass('success').find('.copy-url-link-text').html('Copied!');
      })
    };
  
    self.init()
  }
  
  new ShareLinks();